import axios from 'axios';

const API_URL = '/api/v1/organizations';

const searchOrganizations = ({ filterQuery, pageIndex, pageSize, sortBy }) => {
	return axios.post(`${API_URL}/search`, {
		page: pageIndex,
		count: pageSize,
		sortBy,
		filters: [
			{
				type: 'string',
				name: 'name',
				value: filterQuery,
			},
			{
				type: 'string',
				name: 'id',
				value: filterQuery,
			},
		],
	});
};

const getOrganizationDetails = (id) => {
	return axios.get(`${API_URL}/${id}`);
}

const createOrganization = (params = {}) => axios.post(API_URL, params);

const updateOrganization = (params = {}, id) => axios.put(`${API_URL}/${id}`, params);

const regenerateOrganizationCredentials = (id) => axios.put(`${API_URL}/regenerate-credentials/${id}`);

const deleteOrganizationById = (id) => axios.delete(`${API_URL}/${id}`);

export {
	searchOrganizations,
	getOrganizationDetails,
	createOrganization,
	updateOrganization,
	regenerateOrganizationCredentials,
	deleteOrganizationById,
};
